import { Button, Grid, IconButton, Modal, Paper, TextField, Tooltip, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useState } from "react";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

const useStyles = makeStyles((theme) => ({
  saveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    width: 75,
  },
  actions: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  cancelButton: {
    width: 75,
  },
  textField: {
    width: "100%",
  },
  typography: {
    fontSize: 17,
    color: "#4B4B4B",
  },
  iconRapper: {
    backgroundColor: theme.palette.gif.yellow.color,
    width: 30,
    height: 30,
    borderRadius: "100%",
  },
  icon: {
    marginTop: 5,
    marginLeft: 5,
    color: theme.palette.gif.yellow.dark,
    fontSize: 20,
  },
  paper: {
    position: "absolute",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `30%`,
    left: `45%`,
    transform: `translate(-15%, -25%)`,
  },
}));

const Note = (props) => {
  const classes = useStyles();
  const { text, onSave } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [noteText, setNoteText] = useState(text);
  const modalTitle = "Add Note";

  return <>
    <Tooltip title={noteText}>
      <IconButton onClick={() => setModalOpen(!modalOpen)} size="large">
        <CommentRoundedIcon />
      </IconButton>
    </Tooltip>
    <Modal open={modalOpen} onClose={() => setModalOpen(!modalOpen)}>
      <Paper elevation={3} className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <div className={classes.iconRapper}>
              <EditRoundedIcon className={classes.icon}></EditRoundedIcon>
            </div>
          </Grid>
          <Grid item xs={8}>
            <Typography
              variant="subtitle2"
              className={classes.typography}
              gutterBottom
            >
              {modalTitle}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="outlined-helperText"
              value={noteText || ""}
              multiline
              maxRows={15}
              size="small"
              onChange={(e) => setNoteText(e.target.value)}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4} />
          <Grid item className={classes.actions}>
            <Button
              disableElevation
              variant="contained"
              className={classes.cancelButton}
              onClick={() => {
                setModalOpen(!modalOpen);
                setNoteText(text);
              }}
            >
              Cancel
            </Button>
            <Button
              disableElevation
              variant="contained"
              //size="small"
              className={classes.saveButton}
              onClick={() => {
                setModalOpen(!modalOpen);
                onSave(noteText);
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  </>;
};

export default Note;
